import React, { Fragment, useEffect, useState } from 'react'
import HospitalKitchenModel from 'assets/gltfs/HospitalKitchen'
import ControlWrapper from '../Controls/ControlWrapper'
import MoveView from '../MoveView'
import CanvasWrapper from '../CanvasWrapper'
import { useGLTF } from '@react-three/drei'

export default function HospitalKitchenScene () {
  useGLTF.preload('gltfs/HospitalKitchen/Kitchen_01.gltf')

  const [userInteracted, setUserInteracted] = useState<boolean>(false)
  const [roomAnimationState, setRoomAnimationState] = useState<number>(0)
  const [animatingRoom, setAnimatingRoom] = useState<boolean>(false)

  const [canMove, setCanMove] = useState<boolean>(false)
  const [canDragPan, setCanDragPan] = useState<boolean>(false)

  const [moveCount, setMoveCount] = useState<number>(0)

  useEffect(() => {
    if (userInteracted && !animatingRoom) {
      if (animatingRoom) return

      if (!canMove) {
        setCanMove(true)
      } else {
        setRoomAnimationState(roomAnimationState >= 2 ? 0 : roomAnimationState + 1)
      }
    }
    setUserInteracted(false)
  }, [userInteracted])

  return (
    <Fragment>
      <div className={'w-full h-body relative'}>
        <CanvasWrapper>
          <ControlWrapper>
            <HospitalKitchenModel animationState={roomAnimationState}

                                  startedMoveAnimationCallback={(animationClipNumber: number) => {
                                    setAnimatingRoom(true)
                                    setMoveCount((animationClipNumber + 1 > 2 ? 0 : animationClipNumber + 1))
                                  }}
                                  finishedMoveAnimationCallback={(finishedClipNumber: number) => {
                                    if (animatingRoom) setAnimatingRoom(false)
                                    if (!canDragPan && finishedClipNumber === 0) {
                                      setCanDragPan(true)
                                    }
                                  }}
                                  canPlay={canMove} />
          </ControlWrapper>
        </CanvasWrapper>

        <div className={'absolute top-1 left-1 right-1 md:left-auto md:top-4 md:right-2 backdrop-blur select-none'}>
          <div className={'bg-white rounded-3xl bg-opacity-50 py-1 px-3 md:py-3 md:px-6'}>
            <div className={'flex flex-col items-center'}>
              <div className={'font-museo-round'}>
                <a href={'/'}>
                  <button className={'btn_small--blue md:btn--blue'}>
                    Exit
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MoveView totalCount={2}
                currentCount={moveCount}
                callback={() => {
                  setUserInteracted(true)
                }} />
    </Fragment>
  )
}
